import React from 'react'
import Chart from 'react-apexcharts'
import ChartCard from './ChartCard'
import { formatCurrency } from '../mockData'

export default function AgingChart({ data }) {
    const options = {
        chart: {
            type: 'bar',
            toolbar: { show: false },
            animations: { enabled: true, easing: 'easeinout', speed: 800 },
        },
        plotOptions: {
            bar: {
                horizontal: true,
                borderRadius: 6,
                barHeight: '60%',
                distributed: true,
            },
        },
        xaxis: {
            categories: data.categories,
            labels: {
                style: { colors: '#64748B', fontSize: '12px' },
                formatter: (val) => `R$ ${(val / 1000).toFixed(0)}k`,
            },
        },
        yaxis: {
            labels: {
                style: { colors: '#64748B', fontSize: '12px' },
                maxWidth: 200,
            },
        },
        colors: data.colors,
        legend: { show: false },
        tooltip: {
            theme: 'light',
            y: { formatter: (val) => formatCurrency(val) },
        },
        grid: {
            borderColor: '#E2E8F0',
            strokeDashArray: 4,
        },
        dataLabels: {
            enabled: true,
            formatter: (val) => formatCurrency(val),
            style: { fontSize: '11px', fontWeight: 600, colors: ['#fff'] },
        },
    }

    const series = [{
        name: 'Valor',
        data: data.values,
    }]

    return (
        <ChartCard title="Aging de Contas a Receber" subtitle="Distribuição por faixa de vencimento">
            <Chart options={options} series={series} type="bar" height={300} />
        </ChartCard>
    )
}
